import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MomentPipe, SignalQualityClassPipe } from 'app/pipes/pipes';

@Component({
    selector: 'device-signal-levels',
    imports: [
        CommonModule,
        TranslateModule,
        MomentPipe,
        SignalQualityClassPipe
    ],
    templateUrl: './device-signal-levels.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    styleUrls: ['./device-signal-levels.component.css']
})
export class DeviceSignalLevelsComponent {

  @Input() signalLevels: any[];
  @Input() networkSurveyResults;
  @Input() deviceType;
  signalCollapseState: boolean
}
